export default "__VITE_ASSET__D1$UbP2M__"